module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/titles.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "h1"
  }, [_c('a', {
    attrs: {
      "id": "page_ii"
    }
  }), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _vm._v("OUR PRINCE OF SCRIBES")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Writers Remember Pat Conroy")]), _vm._v(" "), _c('p', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("EDITED BY")]), _vm._v(" Nicole Seitz and Jonathan Haupt"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOREWORD BY")]), _vm._v(" Barbra Streisand"), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AFTERWORD BY")]), _vm._v(" Cassandra King Conroy")]), _vm._v(" "), _c('p', {
    staticClass: "pub"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "Images/pub.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55af9e88","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/title.vue
// module id = 63
// module chunks = 0